module.exports = __webpack_public_path__ + "img/page-header-background-pie.d0b0a529.svg";